import { render, staticRenderFns } from "./details.vue?vue&type=template&id=0bbe4500&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=0bbe4500&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe4500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbe4500')) {
      api.createRecord('0bbe4500', component.options)
    } else {
      api.reload('0bbe4500', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=0bbe4500&scoped=true", function () {
      api.rerender('0bbe4500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/component/AddFeee/details.vue"
export default component.exports